const LAMBDA_URL = process.env.REACT_APP_BOOKS_LAMBDA_URL || "";
const API_KEY = process.env.REACT_APP_BOOKS_API_KEY || "";

export async function submitContactForm({ name, email, subject, message }) {
    const response = await fetch(`${LAMBDA_URL}contact`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Api-Key": API_KEY,
        },
        body: JSON.stringify({ name, email, subject, message }),
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || "Something went wrong. Please try again.");
    }

    return response.json();
}
